// Author YuJiaBei
// Date 2021-06-21 17:50:20

class EmOpcWatchConditionEowc {
constructor({
        id = null,
        eowcIdEow = '',
        eowcNewOld = '',
        eowcPosition = '',
        eowcOperator = '',
        eowcFactor = '',
        eowcFactorType = '',
        eowcEnable = '',
        remark = ''}
= {}) {
    this.id = id;
    this.eowcIdEow = eowcIdEow;
    this.eowcNewOld = eowcNewOld;
    this.eowcPosition = eowcPosition;
    this.eowcOperator = eowcOperator;
    this.eowcFactor = eowcFactor;
    this.eowcFactorType = eowcFactorType;
    this.eowcEnable = eowcEnable;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcWatchConditionEowc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eowcIdEow',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcIdEow',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcWatchEow'
        }
        },
        {
        key: 'eowIdOrigin',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowIdOrigin',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eowIdTarget',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowIdTarget',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eowEowcUniType',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowEowcUniType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: ' AND ' },
                            { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'eowEnable',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowEnable',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'eowcNewOld',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcNewOld',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'NEW' },
                            { value: '2', text: 'OLD' }
            ]
        }
        },
        {
        key: 'eowcPosition',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcPosition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eowcOperator',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcOperator',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: ' = ' },
                            { value: '2', text: ' != ' },
                            { value: '3', text: ' > ' },
                            { value: '4', text: ' < ' },
                            { value: '5', text: ' >= ' },
                            { value: '6', text: ' <= ' }
            ]
        }
        },
        {
        key: 'eowcFactor',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcFactor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eowcFactorType',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcFactorType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: ' 值 ' },
                            { value: '2', text: ' 引用 ' },
                            { value: '3', text: ' 自己新 ' },
                            { value: '4', text: ' 自己旧 ' }
            ]
        }
        },
        {
        key: 'eowcEnable',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.eowcEnable',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    eowcIdEowFilter : "",
    eowEnableFilter : "",
    eowcNewOldFilter : "",
    eowcPositionFilter : "",
    eowcOperatorFilter : "",
    eowcFactorFilter : "",
    eowcFactorTypeFilter : "",
    eowcEnableFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eowcIdEowFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcIdEow',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcWatchEow'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eowEnableFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowEnable',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'eowcNewOldFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcNewOld',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: 'NEW' },
                { value: '2', text: 'OLD' }
            ]
        }
        },
        {
        key: 'eowcPositionFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcPosition',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowcOperatorFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcOperator',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' = ' },
                { value: '2', text: ' != ' },
                { value: '3', text: ' > ' },
                { value: '4', text: ' < ' },
                { value: '5', text: ' >= ' },
                { value: '6', text: ' <= ' }
            ]
        }
        },
        {
        key: 'eowcFactorFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcFactor',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eowcFactorTypeFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcFactorType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' 值 ' },
                { value: '2', text: ' 引用 ' },
                { value: '3', text: ' 自己新 ' },
                { value: '4', text: ' 自己旧 ' }
            ]
        }
        },
        {
        key: 'eowcEnableFilter',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.filter.eowcEnable',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eowcIdEow',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcIdEow',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcWatchEow'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eowcNewOld',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcNewOld',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: 'NEW' },
                { value: '2', text: 'OLD' }
            ]
        }
        },
        {
        key: 'eowcPosition',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcPosition',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowcOperator',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcOperator',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' = ' },
                { value: '2', text: ' != ' },
                { value: '3', text: ' > ' },
                { value: '4', text: ' < ' },
                { value: '5', text: ' >= ' },
                { value: '6', text: ' <= ' }
            ]
        }
        },
        {
        key: 'eowcFactor',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcFactor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eowcFactorType',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcFactorType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' 值 ' },
                { value: '2', text: ' 引用 ' },
                { value: '3', text: ' 自己新 ' },
                { value: '4', text: ' 自己旧 ' }
            ]
        }
        },
        {
        key: 'eowcEnable',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.eowcEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcWatchConditionEowc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcWatchConditionEowc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
